<template>
  <section
    id="admin-device-add"
    style="z-index: 9;"
    :dir="$functions.currentLangDirection()"
  >
    <div>
      <breadcrumb-mobile
        ref="header"
        @on-change-page="changePage"
      />
    </div>
    <b-card style="background-color: #fff;">

      <validation-observer ref="loginValidation">
        <form-wizard
          ref="wizard"
          color="rgb(43, 92, 108)"
          shape="tab"
          step-size="sm"
          :title="null"
          :subtitle="null"
          layout="horizontal"
          next-button-text="بعدی »"
          finish-button-text="تایید ✓"
          back-button-text="« قبلی"
          class="wizard-vertical mb-0"
          style="margin: 0 auto;"
        >
          <!-- @on-change="beforeTabSwitch" -->
          <!-- account datails tab -->
          <tab-content
            title="1"
            icon="mdi mdi-plus"
            :before-change="onChangeImei"
          >
            <b-row>
              <b-col
                cols="12"
                class="mb-0 pb-0"
              >
                <h5 class="mb-0">
                  {{ $t('Add new device') }}
                </h5>
                <small class="text-muted">
                  {{ $t('Text-18') }}
                </small>
              </b-col>
              <b-col md="12">
                <b-col
                  md="6"
                  class="p-0"
                >
                  <b-form-group
                    label="IMEI"
                    label-for="v-IMEI"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="IMEI"
                      rules="required"
                    >
                      <b-form-input
                        id="v-IMEI"
                        v-model="device.imei"
                        name="IMEI"
                        :state="errors.length > 0 ? false : null"
                        placeholder="IMEI"
                        class="numeric-input"
                        maxlength="15"
                        @keyup="imeiChangeEn($event)"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-col>

            </b-row>
          </tab-content>

          <!-- personal info tab -->
          <tab-content
            title="2"
            icon="mdi mdi-sim"
            :before-change="onSimConfigureStatus"
          >
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  {{ $t('Sim number') }}
                </h5>
                <small class="text-muted">{{ $t('Sim number') }}</small>
              </b-col>
              <b-col
                md="12"
                class="p-0"
              >
                <b-col
                  md="6"
                  class="p-0"
                >
                  <b-form-group
                    label=""
                    label-for="v-Sim"
                    class="numeric-input"
                  >
                    <b-form-input
                      id="v-Sim"
                      v-model="device.sim"
                      name="Sim"
                      placeholder="سیم کارتی که درون ردیاب است را وارد کنید"
                      :disabled="simTimerSeconds !== -1"
                      maxlength="11"
                      @keyup="simChangeEn($event)"
                    />
                    <span
                      v-if="simTimerSeconds !== -1"
                      id="simTimerSeconds"
                    >
                      ({{ $t('Please wait') }}...{{ simTimerSeconds }})
                    </span>

                  </b-form-group>
                </b-col>
              </b-col>
            </b-row>
          </tab-content>

          <!-- address -->
          <tab-content
            title="3"
            icon="mdi mdi-layers"
            :before-change="onConfirm"
          >
            <b-row>
              <b-col
                cols="12"
                class="mb-0"
              >
                <h5 class="mb-0">
                  {{ $t('Text-17') }}
                </h5>
              </b-col>
              <b-col
                md="6"
                class="mb-0"
              >
                <b-form-group
                  :label="$t('device-title')"
                  label-for="v-title"
                >
                  <b-form-input
                    id="v-title"
                    v-model="device.title"
                    name="title"
                    :placeholder="$t('Car name')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  :label="$t('Vehicle type')"
                  label-for="v-address"
                >
                  <b-form-select
                    v-model="selectedCategory"
                    :options="options"
                    :select-size="6"
                  />
                </b-form-group>
              </b-col>

            </b-row>
          </tab-content>
          <div
            v-if="loadingWizard"
            class="loader"
          />
        </form-wizard>
      </validation-observer>

    </b-card>
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import {
  BFormSelect,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Vue from 'vue'
import Device from '@/models/device'
// eslint-disable-next-line import/no-named-as-default
import DeviceService from '@/services/device.service'
import BreadcrumbMobile from '@/layouts/breadcrumb.vue'

// eslint-disable-next-line import/no-cycle
import { functions } from '@/functions'
import router from '@/router'
import Config from '../../../config'
import userService from "@/services/user.service";

Vue.prototype.$functions = functions

export default {
  components: {
    BreadcrumbMobile,
    BFormSelect,
    FormWizard,
    TabContent,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
  },
  data() {
    return {
      loadingWizard: false,
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      count: 0,
      selectedCategory: '0',
      options: Config.carTypes,
      simTimerSeconds: -1,
      simStatus: false,
      simTimerPointer: null,
    }
  },
  mounted() {
    this.$refs.header.getTitle('Add New Device')
  },
  methods: {
    checkSimNumber() {
      return new Promise((resolve) => {
        // اول اطلاعات کاربر را دریافت کنید
        userService.getInfo().then(
          res => {
            if (res.status === 'success' && res.result && res.result.data) {
              const loggedInUserMobile = res.result.data.mobile

              // چک کنید که شماره سیم کارت با شماره موبایل کاربر یکسان نباشد
              if (this.device.sim === loggedInUserMobile) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('Error'),
                    text: 'شماره سیم کارت ردیاب نمی‌تواند با شماره موبایل شما یکسان باشد',
                    icon: 'XIcon',
                    variant: 'danger',
                    dir: Vue.prototype.$functions.currentLangDirection(),
                  },
                })
                resolve(false)
              } else {
                resolve(true)
              }
            } else {
              // اگر اطلاعات کاربر دریافت نشد
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Error'),
                  text: 'خطا در دریافت اطلاعات کاربری',
                  icon: 'XIcon',
                  variant: 'danger',
                  dir: Vue.prototype.$functions.currentLangDirection(),
                },
              })
              resolve(false)
            }
          },
          error => {
            // خطا در دریافت اطلاعات
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('Error'),
                text: error.message || 'خطا در بررسی شماره سیم کارت',
                icon: 'XIcon',
                variant: 'danger',
                dir: Vue.prototype.$functions.currentLangDirection(),
              },
            })
            resolve(false)
          },
        )
      })
    },
    changePage(rout) {
      router.push({ name: 'home' }).catch(err => {})
    },
    onChangeImei() {
      return new Promise((resolve, reject) => {
        this.$refs.loginValidation.validate()
          .then(async success => {
            if (success) {
              if (this.device.imei) {
                await DeviceService.check({ imei: this.device.imei })
                  .then(
                    res => {
                      if (res.status === 'error') {
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: this.$t('Error'),
                            text: res.message,
                            icon: 'XIcon',
                            variant: 'danger',
                            dir: Vue.prototype.$functions.currentLangDirection(),
                          },
                        })
                        reject(res.message)
                      } else {
                        this.device = res.result.data
                        resolve(true)
                        // console.log(this.device)
                      }
                    }, error => {
                      this.message = (error.response && error.response.data)
                              || error.message
                              || error.toString()
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: this.$t('Error'),
                          text: this.message,
                          icon: 'XIcon',
                          variant: 'danger',
                          dir: Vue.prototype.$functions.currentLangDirection(),
                        },
                      })
                      reject(new Error('error'))
                    },
                  )
              } else {
                reject(new Error('error'))
              }
            }
          })
      })
    },
    onSimConfigureStatus() {
      if (!this.simStatus) {
        this.onConfigure()

        // this.$toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'خطای تنظیم سیمکارت',
        //     text: 'سیمکارت بررسی و تنظیم نشده است.',
        //     icon: 'XIcon',
        //     variant: 'danger',
        //   },
        // })

        return false
      }
      return true
    },
    onConfigure() {
      return new Promise((resolve, reject) => {
        this.$refs.loginValidation.validate()
          .then(async success => {
            if (success) {
              if (this.device.imei && this.device.sim) {
                // چک کردن شماره سیم کارت
                const isSimValid = await this.checkSimNumber()
                if (!isSimValid) {
                  // eslint-disable-next-line prefer-promise-reject-errors
                  reject('شماره سیم کارت نامعتبر است')
                  return
                }
                DeviceService.configure(this.device)
                  .then(
                    res => {
                      if (res.status === 'error') {
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: this.$t('Error'),
                            text: res.message,
                            icon: 'XIcon',
                            variant: 'danger',
                            dir: Vue.prototype.$functions.currentLangDirection(),
                          },
                        })
                        reject(res.message)
                      } else {
                        const seconds = 30
                        this.simTimerSeconds = seconds
                        this.simTimerPointer = setInterval(async () => {
                          if (this.simTimerSeconds % 5 === 0) {
                            DeviceService.configureStatus(this.device)
                              .then(
                                resp => {
                                  if (resp.status === 'error') {
                                    reject(res.message)
                                  } else {
                                    this.simStatus = true
                                    resolve(true)
                                    this.simTimerSeconds = -1
                                    clearInterval(this.simTimerPointer)
                                    this.$refs.wizard.nextTab()
                                    this.$toast({
                                      component: ToastificationContent,
                                      props: {
                                        title: this.$t('Message'),
                                        text: this.$t('The operation was successful'),
                                        icon: 'XIcon',
                                        variant: 'success',
                                        dir: Vue.prototype.$functions.currentLangDirection(),
                                      },
                                    })
                                  }
                                },
                              )
                          }
                          if (this.simTimerSeconds > 0) {
                            this.simTimerSeconds -= 1
                          } else if (!this.simStatus) {
                            this.simTimerSeconds = -1
                            clearInterval(this.simTimerPointer)
                            this.$toast({
                              component: ToastificationContent,
                              props: {
                                title: this.$t('Error'),
                                text: res.message,
                                icon: 'XIcon',
                                variant: 'danger',
                                dir: Vue.prototype.$functions.currentLangDirection(),
                              },
                            })
                          }
                        }, 1000)
                        resolve(true)
                      }
                    },
                  ).catch(error => {
                    this.message = (error.response && error.response.data)
                        || error.message
                        || error.toString()
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: this.$t('Error'),
                        text: this.message,
                        icon: 'XIcon',
                        variant: 'danger',
                        dir: Vue.prototype.$functions.currentLangDirection(),
                      },
                    })
                    reject(this.message)
                  })
              }
            }
          })
      })
    },
    onConfirm() {
      // console.log('Confirm clicked') // برای بررسی اینکه آیا تابع اجرا می‌شود یا خیر
      return new Promise((resolve, reject) => {
        this.$refs.loginValidation.validate()
          .then(success => {
            if (success) {
              this.device.category = this.selectedCategory
              if (this.device.imei && this.device.sim && this.device.title) {
                DeviceService.confirm(this.device)
                  .then(
                    res => {
                      if (res.status === 'error') {
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: this.$t('Error'),
                            text: res.message,
                            icon: 'XIcon',
                            variant: 'danger',
                            dir: Vue.prototype.$functions.currentLangDirection(),
                          },
                        })
                        reject(res.message)
                      } else {
                        resolve(true)
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: this.$t('Message'),
                            text: this.$t('The operation was successful'),
                            icon: 'XIcon',
                            variant: 'success',
                            dir: Vue.prototype.$functions.currentLangDirection(),
                          },
                        })
                        Vue.prototype.$functions.deviceServerSocketReconnect(() => {
                          this.$router.push('/')
                        })
                      }
                    },
                  ).catch(error => {
                    this.message = (error.response && error.response.data)
                          || error.message
                          || error.toString()
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: this.$t('Error'),
                        text: this.message,
                        icon: 'XIcon',
                        variant: 'danger',
                        dir: Vue.prototype.$functions.currentLangDirection(),
                      },
                    })
                    reject(this.message)
                  })
              }
            }
          })
      })
    },
    onCancel() {
      this.show = false
      this.$router.push({ name: 'device-list' })
    },
    imeiChangeEn(event) {
      this.device.imei = this.$functions.fixNumbers(event.target.value)
    },
    simChangeEn(event) {
      this.device.sim = this.$functions.fixNumbers(event.target.value)
    },
  },
}
</script>
<style>
[dir=ltr] {
  direction: ltr !important;
  text-align: left;
}
#admin-device-add .wizard-nav-pills{
  border-right: 1px solid rgba(34,41,47,.08);
  padding-right: 2.5rem;
}
#admin-device-add .wizard-card-footer{
  padding-top: 0px !important;
}
/* This is a css loader. It's not related to vue-form-wizard */
#admin-device-add .loader,
#admin-device-add .loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
#admin-device-add .loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #e74c3c;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
#admin-device-add .wizard-card-footer{
  margin-top: 40px;
}
#admin-device-add{
  background-color: #fff;
}
@media (max-width: 768px) {
  #admin-device-add{
    margin: -28px;
  }
  #admin-device-add .card{
    height: calc( 100vh - 150px);
    top: -53px;
  }

}
@media (min-width: 768px) {
  #admin-device-add{
    background-color: #fff !important;
    width: 800px;
    margin: 0 auto;
  }
}
</style>
